
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.377 10.512a6.143 6.143 0 11-12.286 0 6.143 6.143 0 0112.286 0zm1.369 0a7.512 7.512 0 01-12.23 5.847L4.714 21.16l-.968-.968 4.788-4.788a7.512 7.512 0 1113.212-4.893z","fill":"currentColor"}})])
          )
        }
      }
    